var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 27,
    viewBox: "0 0 43 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 86 55"
  }, /*#__PURE__*/React.createElement("image", {
    width: 86,
    height: 55,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAA3CAMAAAChIE06AAAANlBMVEVHcEz1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjL1VjKTzyBbAAAAEXRSTlMAowft0cJfEHB/SffeHo4yvJib8FMAAAGTSURBVFjD7ZjrboMwDIXJ/R7w+7/sHJoQyqCsw606aecXEeIjtY/t0GGgkBUwpYFaHlCSE1N5LFiwxFg3U0EYUmoKNyxkUiyDppGQOi5UmAixqmPBk1H1igqRk5pLWptJTXYzl2ohJjJZNZeqlUZlsmouuWBJTNbMFXvqJkJziZUjPJ25AvZGMpPVzlXEW78hMFkngRnych0MTedCpRUWGFHnwjyl9Wqk6VyYJylWK0XUue5Sdslkfo2R39fXbVDqQYS79ew/86y2u90Ki9lLeFahbGZ6cN8/fuuRyna5dgeyaZPQn0qfhv43VIjmJViI/iVYtJTaFbuIPZD8eGx4AVZqM3A/EWNZnVyWFNvHdz7AMn0gt3Road08FYWzss8ByxxWBxe7WHs+tMpHh8GnBdY8lw2S6zhge9jAz6eWrT+WLWeEchXqru0bsY+CMLYgYAjTc0HAN9sD5SVl0d3SJ5yLPWV6TpkRhAZT/Mxgn1QOGBidBuPV3+lg/9j3YNXeefK68qbgadTPJSPdfgNrfy99AX54n9VOEkSMAAAAAElFTkSuQmCC"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "alert_system2",
    width: 43,
    height: 27,
    fill: "url(#pattern)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlert);
export default __webpack_public_path__ + "static/media/system_alert.b6a573ee8237bfb404f2f9d80903bb8e.svg";
export { ForwardRef as ReactComponent };